module.exports = __webpack_public_path__ + "img/building-wall-panels-1.b7478bd5.jpeg";